module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap flex-column"
  }, [_c('mu-infinite-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pay.loading),
      expression: "pay.loading"
    }],
    staticClass: "load maskloading",
    attrs: {
      "loading": _vm.pay.loading,
      "loadingText": _vm.pay.message
    }
  }), _vm._v(" "), (_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadShow) ? _c('div', {
    staticClass: "flex-item"
  }, [_c('div', [_c('div', {
    staticClass: "orders-list detail"
  }, [(_vm.orderStateType != 0 && _vm.orderStateType != 2 && _vm.orderStateType != 10 && _vm.orderStateType != 11) ? _c('div', {
    staticClass: "time-line four"
  }, _vm._l((_vm.memOrderDetailMsg.orderOperMsgs), function(orderType, typeIndex) {
    return (typeIndex != 0 && typeIndex != 5) ? _c('div', {
      staticClass: "time-line-item",
      class: {
        'nowStyle': orderType.operIndex == 2,
        'finishStyle': orderType.operIndex == 1
      }
    }, [_c('p', {
      staticClass: "state"
    }, [_vm._v(_vm._s(orderType.operName))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), (orderType.operIndex != 3) ? _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(orderType.operTime))]) : _vm._e()]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm.orderStateType == 10 || _vm.orderStateType == 11) ? _c('div', {
    staticClass: "time-line three"
  }, _vm._l((_vm.memOrderDetailMsg.orderOperMsgs), function(orderType, typeIndex) {
    return _c('div', {
      staticClass: "time-line-item",
      class: {
        'nowStyle': orderType.operIndex == 2,
        'finishStyle': orderType.operIndex == 1
      }
    }, [_c('p', {
      staticClass: "state"
    }, [_vm._v(_vm._s(orderType.operName))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), (orderType.operIndex != 3) ? _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(orderType.operTime))]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "orders-list-item"
  }, [_c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state"
  }, [_vm._v("\n              订单状态："), _c('span', {
    staticClass: "primary"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.orderStateName))]), _vm._v(" "), (_vm.memOrderDetailMsg.orderStateName == '等待支付') ? _c('samp', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("支付剩余:" + _vm._s(_vm.memOrderDetailMsg.remainPayTime))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" 订单号：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.stOrderId))]), _vm._v(" "), _c('br'), _vm._v(" 下单时间：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.orderTime))])]), _vm._v(" "), (_vm.orderStateType == 0) ? _c('div', {
    staticClass: "operate"
  }, [_c('mu-raised-button', {
    staticClass: "orders-button mu-raised-button-grad",
    attrs: {
      "label": "取消订单"
    },
    on: {
      "click": function($event) {
        return _vm.cancelOrder(_vm.orderStateType, _vm.memOrderDetailMsg.stOrderId)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.orderStateType == 1 || _vm.orderStateType == 3 || _vm.orderStateType == 4 || _vm.orderStateType == 12 || _vm.orderStateType == 13) ? _c('div', {
    staticClass: "operate"
  }, [_c('mu-raised-button', {
    staticClass: "orders-button mu-raised-button-grad fr",
    attrs: {
      "label": "申请退单"
    },
    on: {
      "click": function($event) {
        return _vm.cancelOrder(_vm.orderStateType, _vm.memOrderDetailMsg.stOrderId)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.orderStateType == 2 || _vm.orderStateType == 10) ? _c('div', {
    staticClass: "operate"
  }, [_c('mu-raised-button', {
    staticClass: "orders-button mu-raised-button-grad fr",
    attrs: {
      "label": "立即购买"
    },
    on: {
      "click": function($event) {
        return _vm.buyNow()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.orderStateType == 9 && _vm.commonFinished == false) ? _c('div', {
    staticClass: "operate"
  }, [_vm._v("=\"去评价\" class=\"orders-button fr\" primary @click=\"evaluateJump()\" />\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('mu-list', _vm._l((_vm.memOrderDetailMsg.goodsOrderMsgs), function(listShop, shopIndex) {
    return _c('myOrdersItem', {
      key: shopIndex,
      attrs: {
        "width": 150,
        "height": 150,
        "cartitem": listShop
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state"
  }, [_vm._v("\n              收货人："), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.orderAddrMsg && _vm.memOrderDetailMsg.orderAddrMsg.consignee))]), _vm._v(" "), _c('br'), _vm._v(" 联系电话：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.orderAddrMsg && _vm.memOrderDetailMsg.orderAddrMsg.mobile))]), _vm._v(" "), _c('br'), _vm._v(" 收货地址：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(" " + _vm._s(_vm.memOrderDetailMsg.orderAddrMsg && _vm.memOrderDetailMsg.orderAddrMsg.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state"
  }, [_vm._v("\n              支付方式：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(" " + _vm._s(_vm.memOrderDetailMsg.payTypeName))])])]), _vm._v(" "), (_vm.memOrderDetailMsg.invoiceDat && _vm.memOrderDetailMsg.invoiceData.doInvoice == '1') ? _c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state"
  }, [_vm._v("\n              发票类型："), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.invoiceData && _vm.memOrderDetailMsg.invoiceData.invoiceTypeName))]), _vm._v(" "), _c('br'), _vm._v(" 发票内容：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.invoiceData && _vm.memOrderDetailMsg.invoiceData.invoiceContentName))]), _vm._v(" "), _c('br'), _vm._v(" 发票抬头：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.invoiceData && _vm.memOrderDetailMsg.invoiceData.invoiceHead))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state money"
  }, [_vm._v("\n              商品总额："), _c('span', {
    staticClass: "primary"
  }, [_vm._v("￥  " + _vm._s(_vm.memOrderDetailMsg.totalPrice))]), _vm._v(" "), _c('br'), _vm._v(" 运费：\n              "), _c('span', {
    staticClass: "primary"
  }, [_vm._v("￥" + _vm._s(_vm.memOrderDetailMsg.postPrice))]), _vm._v(" "), _c('br'), _vm._v(" 使用优惠券：\n              "), _c('span', {
    staticClass: "primary"
  }, [_vm._v("-￥" + _vm._s(_vm.memOrderDetailMsg.discountPrice))]), _vm._v(" "), _c('br'), _vm._v(" 使用红包:\n              "), _c('span', {
    staticClass: "primary"
  }, [_vm._v("-￥" + _vm._s(_vm.memOrderDetailMsg.redpacketPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "orderSum"
  }, [_vm._v("\n              实付金额："), _c('span', {
    staticClass: "primary"
  }, [_vm._v("￥" + _vm._s(_vm.memOrderDetailMsg.finalPrice))])])])], 1), _vm._v(" "), (_vm.orderStateType == 0) ? _c('div', {
    staticClass: "fullbtn-box"
  }, [_c('mu-raised-button', {
    staticClass: "full wx",
    attrs: {
      "label": "微信支付",
      "fullWidth": ""
    },
    on: {
      "click": _vm.submitOrder
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "full Union",
    attrs: {
      "label": "银联支付",
      "fullWidth": ""
    },
    on: {
      "click": _vm.submitUnionOrder
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.quitOrder,
      "title": "取消订单",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.quitOrder = false
      }
    }
  }, [_vm._v("\n      您确定要取消这个订单么?\n      "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.quitOrder = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "是"
    },
    on: {
      "click": function($event) {
        return _vm.doQuitOrder(1)
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.chargeBack,
      "title": "申请退单",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.chargeBack = false
      }
    }
  }, [_vm._v("\n      您确定要申请退单么?\n      "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.chargeBack = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "是"
    },
    on: {
      "click": function($event) {
        return _vm.doChargeBack()
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.contactService,
      "title": "申请退单请联系客服",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer fullContainer"
    },
    on: {
      "close": function($event) {
        _vm.contactService = false
      }
    }
  }, [_vm._v("\n      400-832-2777\n      "), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": function($event) {
        return _vm.phoneCall('400-832-2777')
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-box"
  }, [_c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-box"
  }, [_c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a49fddae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/orderdetail.vue
// module id = 417
// module chunks = 68